import * as colors from './colors'

const styles = {
    contextBar: {
        backgroundColor: colors.gray,
        color: colors.textColor,
        display: 'flex',
        flexDirection: 'column',
        gridColumnStart: 'left',
        gridColumnEnd: 'controlBar',
        gridRowStart: 'subHeader',
        gridRowEnd: 'end',
    },
    contextBarBottom: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },
    contextBarTop: {
        flexGrow: '1',
    },
    iconCtr: {
        padding: '10px',
        textAlign: 'center',
        fontSize: '20px',
    },
    spacer: {
        backgroundColor: colors.secondaryOne,
        height: '44px',
    },
}

export default styles
